import React from "react";

import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";

import { useUpdateEmailTemplateMutation } from "store/services/emailTemplateApi";

const ToggleEmailTemplateStatus = ({ emailTemplateDetail }) => {
  // RTK Query
  const [updateEmailTemplate, { isLoading: updatingEmailTemplate }] =
    useUpdateEmailTemplateMutation();

  // methods
  const handleUpdateEmailTemplateStatus = async () => {
    try {
      await updateEmailTemplate({
        ...emailTemplateDetail,
        isActive: !emailTemplateDetail?.isActive,
      }).unwrap();
      toast.info(
        `EmailTemplate successfully ${
          emailTemplateDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(
        err?.data?.message ?? "Couldn't update emailTemplate status!"
      );
    }
  };

  return (
    <EnableDisableButton
      suffix="Email Template"
      isActive={emailTemplateDetail?.isActive}
      loading={updatingEmailTemplate}
      onClick={handleUpdateEmailTemplateStatus}
    />
  );
};

export default ToggleEmailTemplateStatus;
